import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import EmailStats from '../components';

const mapStateToProps = state => ({
  literals: state.i18n.literals.emailStats,
});

export default withRouter(connect(mapStateToProps)(EmailStats));
